<template>
    <div class="LogicSettingsItem1">
							
        <div v-if="arrBox.length > 0" class="show-box"  >
            
            <div class="arrBox" v-for="(boxItem, boxIndex) in arrBox" :key="boxIndex">
                <div>
                    <el-button v-if="boxItem.conditionList.length == 0" size="small" @click="adddom(boxItem)">{{$t('main.AddConditions')}}</el-button>
                    <div class="conditionList" v-for="(item, index) in boxItem.conditionList" :key="index">
                        
                        <!-- <p class="title" style="width: 70px;text-align: right">{{index != 0 ? '并且' : ''}}当该题</p> -->
                        <span v-if="index == 0" style=" margin-left: 65px;">{{ $t('main.When') }}</span>
                        <span v-if="index == 0 && showTypeList.indexOf(activeQuestion.questionsTypeId) == -1">{{$t('main.ThisQuestion')}}</span>
                        <el-select
                            class="conditionsInput"
                            v-if="index > 0"
                            :disabled="index > 1"
                            size="small"
                            v-model="boxItem.condition"
                        >
                            <el-option
                                v-for="(andOrItem, andOrIndex) in andOrList"
                                :key="andOrIndex"
                                :label="andOrItem.labelName"
                                :value="andOrItem.value"
                            ></el-option>
                        </el-select>
                        
                        <div class="labelClass" style=" margin-left: 15px;">
                            <el-select size="small" disabled v-model="item.questionId" value-key="questionId">
                                <el-option 
                                    v-for="ques in questionsList" :key="ques.qid" 
                                    :label="
                                        ques.questionIndex
                                        ? 'Q' + ques.questionIndex + ' ' + $functions.htmlFormat(ques.questionsName)
                                        : $functions.htmlFormat(ques.questionsName)
                                    " 
                                    :value="ques.qid"></el-option>
                            </el-select>
                        </div>

                        <div  class="labelClass show-type" style=" margin-left: 15px; margin-right: 15px">
                            <el-select size="small" v-model="item.questionState" :placeholder="$t('main.PleaseSelectACondition')" value-key="questionId">
                                <el-option v-for="item in showLogicCondition" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                        
                        <!-- 选项  -->
                        <div class="labelClass"
                            v-if="amswerOptionTypeList.indexOf(activeQuestion.questionsTypeId) !== -1"
                            v-show="item.questionState != 3 && item.questionState != 4"
                        >
                            <template v-for="ques in questionsList"  >
                                <el-select :key="ques.qid" v-if="item.questionId == ques.qid" size="small" v-model="item.optionId" :placeholder="$t('main.PleaseSelectAnOption')" value-key="id">
                                    <el-option v-for="el in ques.optionList" :key="el.oid" :label="$functions.htmlFormat(el.labelName)" :value="el.oid">
                                        {{ $functions.htmlFormat(el.labelName) }}
                                    </el-option>
                                    <el-option :label="$t('main.AnyOption')" :value="0"></el-option>
                                </el-select>
                            </template>
                        </div>
                        
                        <!-- 大小选项 -->
                        <el-select 
                            v-if="amswerNumTypeList.indexOf(activeQuestion.questionsTypeId) !== -1 &&
                            (item.questionState != 3 || item.questionState == 4)"
                            size="small" 
                            v-model="item.startNum" 
                            :placeholder="$t('main.StartingScore')"
                            class="start-Num"
                        >
                            <el-option 
                                v-for="(info, index) in item.orderSetting" 
                                :key="index" 
                                :label="item.activeStartNum + index"
                                :value="item.activeStartNum + index"
                            >{{item.activeStartNum + index}}</el-option>
                        </el-select>
                        <!-- 结束分数 -->
                        <el-select 
                            v-if="amswerNumTypeList.indexOf(item.typeId) !== -1 && 
                            item.questionState == 8"
                            size="small" 
                            v-model="item.endNum" 
                            :placeholder="$t('main.EndScoreScore')"
                            class="max-Num"
                        >
                            <el-option 
                                v-for="(info, index) in item.orderSetting - item.startNum -1" 
                                :key="index" 
                                :label="item.activeStartNum + index + item.startNum + 1"
                                :value="item.activeStartNum + index + item.startNum + 1"
                            >{{item.activeStartNum + index + item.startNum + 1}}</el-option>
                        </el-select>
                        <div class="icon_num" >
                            <i class="icon iconfont iconjian" @click="removeDom(boxItem, item)"></i>
                            <i class="icon iconfont iconjia" @click="adddom(boxItem,index)"></i>
                        </div>
                    </div>
                    <div class="quesBoundList">
                        <span class="title" style="margin: 0 10px;">{{$t('main.ThenDisplay')}}</span>
                        <div>
                            <el-button  size="small" v-if="boxItem.quesBoundList.length == 0" @click="addQuestion(boxItem)">{{$t('main.AddTestQuestions')}}</el-button>
                        </div>
                        <div >
                            <div class="quesBoundList-item" v-for="(item, index) in boxItem.quesBoundList" :key="`quesBoundList${index}`">
                                <el-select size="small" v-model="item.qid" :placeholder="$t('main.PleaseSelectAQuestion')" value-key="id">
                                    <el-option
                                        v-for="info in isShowQuesList"
                                        :key="info.qid"
                                        :disabled="info.quesIndex <= activeQuestion.quesIndex && info.questionsTypeId != '25'"
                                        :label="
                                            info.questionIndex
                                                ? 'Q' + info.questionIndex + ' ' + $functions.htmlFormat(info.questionsName)
                                                : $functions.htmlFormat(info.questionsName)
                                        "
                                        :value="info.qid"
                                    ></el-option>
                                </el-select>

                                <div class="icon_num">
                                    <i class="icon iconfont iconjian" @click="removeDomain(boxItem, index)"></i>
                                    <i class="icon iconfont iconjia" @click="addDomain(boxItem, index)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                <i class="el-icon-delete" @click="delCondition(boxIndex)"></i> 
            </div>
        </div>
        
        <el-button size="small" @click="addShowClick">{{$t('main.AddDisplayLogic')}}</el-button>
    </div>
</template>

<script>
export default {
    // 逻辑设置 - 显示逻辑 - 满足当前试题的条件，控制多个试题的显示状态
    name: 'LogicSettingsItem1', 
    props: {
        questionsList: {
            type: Array,
            default: () => []
        },
        showLogicalSettings: {
            type: Array,
            default: () => []
        },
        activeQuestion: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            showLogicCondition: [
				{
					label: this.$t('main.Selected'),
					value: 1
				},
				{
					label: this.$t('main.notSelected'),
					value: 2
				},
				{
					label: this.$t('main.show'),
					value: 3
				},
				{
					label: this.$t('main.NoShow'),
					value: 4
				}
			],
			amswerNumTypeList: ['38'], // 选择数字范围类型
			amswerOptionTypeList: ['6', '8', '9', '10', '12',], // 选择选项类型
            conditionListBox: [],
            conditionList: [], // 绑定该题的显示条件
            arrBox: [], 
            andOrList: [
				{
					labelName: this.$t('main.Just'),
					value: 1
				},
				{
					labelName: this.$t('main.Perhaps'),
					value: 2
				}
			],
            isShowQuesList: [],
            showTypeList: ['6','8', '10', '12', '19']
        }
    },
    created() {
        this.showLogicInit()
    },
    methods:{
        // 初始化条件
        showLogicInit() {
            let quesBound = this.activeQuestion.logicalSettings.quesBound
            if (quesBound.length > 0) {
                this.questionsList.forEach((info) => {
                    if (quesBound.indexOf(info.qid) !== -1 && info.logicalSettings.show.length > 0) {
                        info.logicalSettings.show.forEach((val => {
                            if (!val) return
                            let { conditionList, condition } = val
                            // console.log(conditionList)
                            // console.log(info.logicalSettings.show)
                            if (this.arrBox.length > 0) {
                                let result = false
                                this.arrBox = this.arrBox.map(item => {
                                    result = this.equalsObj(item.conditionList,conditionList)
                                    if (result) {
                                        item.quesBoundList.push({
                                            qid: info.qid
                                        })
                                    }
                                    return item
                                })
                                if (!result){
                                    conditionList.forEach((ele) => {
                                        if (ele.questionId == this.activeQuestion.qid) {
                                            result = true
                                        }
                                    })
                                    if (result) {
                                        this.arrBox.push({
                                            conditionList: conditionList,
                                            quesBoundList: [{
                                                qid: info.qid
                                            }],
                                            condition: condition
                                        })
                                    }
                                }
                                // this.arrBox.push({
                                //         conditionList: conditionList,
                                //         quesBoundList: [{
                                //             qid: info.qid
                                //         }],
                                //         condition: condition
                                //     })
                                // }
                            } else {
                                let result = false
                                let arr = []
                                conditionList.forEach((item) => {
                                    let index = arr.findIndex(a => { return a.qid == info.qid})
                                    if (item.questionId == this.activeQuestion.qid && index === -1) {
                                        result = true
                                        arr.push({
                                            qid: info.qid
                                        })
                                    }
                                })
                                if (result) {
                                    this.arrBox.push({
                                        conditionList: conditionList,
                                        quesBoundList: arr,
                                        condition: condition
                                    })
                                }
                            }
                        }))
                    }
                })
            }

             this.isShowQuesList = this.questionsList.filter((info) => {
                return info.questionsTypeId != '26'
            })
            // console.log(`this.isShowQuesList:${this.isShowQuesList}`)
            if (this.showTypeList.indexOf(this.activeQuestion.questionsTypeId) == -1 && 
                this.activeQuestion.questionsTypeId != '38') {
                this.showLogicCondition = [
                    {
                        label: this.$t('main.show'),
                        value: 3
                    },
                    {
                        label: this.$t('main.NoShow'),
                        value: 4
                    }
                ];
            } else if (this.activeQuestion.questionsTypeId == '38') {
                this.showLogicCondition =  [
                    {
                        value: 5,
                        label: this.$t('main.EqualTo')
                    },
                    {
                        value: 6,
                        label: this.$t('main.GreaterThan')
                    },
                    {
                        value: 7,
                        label: this.$t('main.LessThan')
                    },
                    {
                        value: 8,
                        label: this.$t('main.Betweenness')
                    },{
                        label: this.$t('main.show'),
                        value: 3
                    },
                    {
                        label: this.$t('main.NoShow'),
                        value: 4
                    }
                ]
            } else {
                this.showLogicCondition = [
                    {
                        label: this.$t('main.Selected'),
                        value: 1
                    },
                    {
                        label: this.$t('main.notSelected'),
                        value: 2
                    },
                    {
                        label: this.$t('main.show'),
                        value: 3
                    },
                    {
                        label: this.$t('main.NoShow'),
                        value: 4
                    }
                ];
            }
        },
        // 删除条件
        delCondition(index) {
            this.arrBox.splice(index, 1);
        },
        /**
         * 判断此对象是否是Object类型
         * @param {Object} obj  
         */
        isObject(obj) {
            return Object.prototype.toString.call(obj) === '[object Object]';
        },
        /**
         * 判断此类型是否是Array类型
         * @param {Array} arr 
         */
        isArray(arr) {
            return Object.prototype.toString.call(arr) === '[object Array]';
        },
        /**
         *  深度比较两个对象是否相同
         * @param {Object} oldData 
         * @param {Object} newData 
         */
        equalsObj(oldData, newData) {
            // 类型为基本类型时,如果相同,则返回true
            if (oldData === newData) return true;
            if (this.isObject(oldData) && this.isObject(newData) && Object.keys(oldData).length === Object.keys(newData).length) {
                // 类型为对象并且元素个数相同

                // 遍历所有对象中所有属性,判断元素是否相同
                for (const key in oldData) {
                if (oldData.hasOwnProperty(key)) {
                    if (!this.equalsObj(oldData[key], newData[key]))
                    // 对象中具有不相同属性 返回false
                    return false;
                }
                }
            } else if (this.isArray(oldData) && this.isArray(oldData) && oldData.length === newData.length) {
                // 类型为数组并且数组长度相同

                for (let i = 0, length = oldData.length; i < length; i++) {
                if (!this.equalsObj(oldData[i], newData[i]))
                    // 如果数组元素中具有不相同元素,返回false
                    return false;
                }
            } else {
                // 其它类型,均返回false
                return false;
            }

            // 走到这里,说明数组或者对象中所有元素都相同,返回true
            return true;
        },
        setShowLogicalObj(){
            let showLogicalObj = {
				questionId: this.activeQuestion.qid, // 题目
				questionState: 1, // 题目状态
				optionId: 0, // 状态条件（题目状态是选中时）
				startNum: '', // 起始分数 如果不是'介于' 默认使用起始分数
				endNum: '', // 结束分数
                typeId: this.activeQuestion.questionsTypeId
			}
            let blankType = ['2','3','4','5','35','34']
            if (this.showTypeList.indexOf(this.activeQuestion.questionsTypeId) !== -1 || 
                blankType.indexOf(this.activeQuestion.questionsTypeId) !== -1
            ) {
                showLogicalObj.questionState = 3
            } else if(this.activeQuestion.questionsTypeId == '38') {
                showLogicalObj.questionState = 5
				showLogicalObj.orderSetting = this.activeQuestion.orderSetting
				showLogicalObj.activeStartNum = this.activeQuestion.startNum
            } else {
                showLogicalObj.questionState = 1
            }
            return showLogicalObj
        },
        addShowClick() {
            this.arrBox.push({
                condition: 1,
                conditionList: [this.setShowLogicalObj()],
                quesBoundList: [{
                    qid: '',
                }]
            })
        },
        removeDom(boxItem, item) {
            var index = boxItem.conditionList.indexOf(item);
            console.log(index)
			if (index !== -1) {
				boxItem.conditionList.splice(index, 1);
			}
        },
        adddom(boxItem,index) {
			if (index != 'undefined') {
				boxItem.conditionList.splice(index + 1, 0, this.setShowLogicalObj());
			} else {
				boxItem.conditionList.push(this.setShowLogicalObj());
			}
        },
        removeDomain(boxItem, index) {
            boxItem.quesBoundList.splice(index, 1);
            console.log(this.arrBox)
        },
        addDomain(boxItem, index) {
            boxItem.quesBoundList.splice(index + 1, 0, {
                qid: '',
            });
        },
        addQuestion(boxItem) {
            boxItem.quesBoundList.push({
                qid: '',
            });
        },
    }
}
</script>


<style scoped lang="scss">
.LogicSettingsItem1{
    margin-top: 16px;
    .show-box{
        margin-bottom: 22px;
    }
    .arrBox{
        margin-top: 22px;
        display: flex;
        justify-content: space-between;
    }
    .el-icon-delete{
        cursor: pointer;
        font-size: 20px;
        color: #ccc;
        margin-right: 30px;
    }
	.show-type{
		width: 90px;
	}
	.start-Num,.max-Num{
		width: 100px;
	}
    .max-Num{
        margin-left: 15px;
    }
	.conditionList, 
    .quesBoundList-item{
		display: flex;
		align-items: center;
	}
    .quesBoundList{
		display: flex;
        align-items: baseline;
        margin-top: 20px;
    }
    .conditionList+.conditionList,
    .quesBoundList-item+.quesBoundList-item{
        margin-top: 16px;
    }
	.icon{
		cursor: pointer;
	}
    .title{
        // width: 70px;
        text-align: right;
    }
    .conditionsInput{
        width: 80px;
    }
}
</style>